"use client"

import React from "react"
import { Provider } from "react-redux"
import { PlatformSessionProvider } from "@/lib/auth/client"
import { NextIntlClientProvider } from "next-intl"
import ThemeAttributeSetter from "@components/providers/ThemeAttributeSetter"
import { ThemeProvider } from "./ThemeProvider"
import QueryProvider from "./QueryProvider"
import { store } from "@/redux-store"
import { MarketplaceProvider } from "@/contexts/MarketplaceContext"
import ConfirmDialogProvider from "@components/providers/ConfirmDialogProvider"
import { SonnerProvider } from "./SonnerProvider"
import SubscriptionGuard from "@components/auth/SubscriptionGuard"
import ImpersonationBanner from "@/components/impersonation/ImpersonationBanner"

export default function ClientProviders({
  children,
  locale = "tr",
  messages = {},
}: {
  children: React.ReactNode
  locale?: string
  messages?: Record<string, unknown>
}) {
  return (
    <Provider store={store}>
      <NextIntlClientProvider messages={messages} locale={locale} timeZone="Europe/Istanbul">
        <ThemeProvider>
          <ThemeAttributeSetter>
            <PlatformSessionProvider>
              <SubscriptionGuard>
                <QueryProvider>
                  <ImpersonationBanner />
                  <ConfirmDialogProvider>
                    <MarketplaceProvider>{children}</MarketplaceProvider>
                  </ConfirmDialogProvider>
                </QueryProvider>
              </SubscriptionGuard>
            </PlatformSessionProvider>
          </ThemeAttributeSetter>
        </ThemeProvider>
      </NextIntlClientProvider>
      <SonnerProvider />
    </Provider>
  )
}
